var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.lowercaseTag,style:({ backgroundColor: _vm.colour || '#5c5e6459' })},[_vm._v(" "+_vm._s(_vm.tag)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }